import {Routes} from '@angular/router';

import {DashboardComponent} from './dashboard/dashboard.component';
import {ErrorComponent} from './login/error.component';
import {NotFoundComponent} from './login/not-found.component';
import {AccessLimitedComponent} from './error-pages/access-limited.component';
import {AuthenticationGuard} from './shared/authentication/authentication-guard';
import {AccessLimitedGuard} from './shared/authentication/roles/access-limited-guard';
import {RouteGuard} from './shared/authentication/roles/route-guard';

// Actual view components

export const ROUTES: Routes = [
  {path: '404', component: NotFoundComponent},
  {path: 'error/:type', component: ErrorComponent},
  {path: 'access-limited', component: AccessLimitedComponent, canActivate: [AuthenticationGuard]},
  {
    // Pathless grouping route: enforces the access-limited gate centrally for every
    // child route, so restricted users are always redirected to /access-limited.
    path: '',
    canActivateChild: [AccessLimitedGuard],
    children: [
  {
    path: 'settings',
    loadChildren: () => import('./+settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'workflows',
    loadChildren: () => import('./workflows/workflows.module').then(m => m.WorkflowsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'employees',
    loadChildren: () => import('./+employees/employees.module').then(m => m.EmployeesModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'ess',
    loadChildren: () => import('./+ess/ess.module').then(m => m.ESSModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'mss',
    loadChildren: () => import('./+mss/mss.module').then(m => m.MSSModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'company',
    loadChildren: () => import('./+organizations/organizations.module').then(m => m.OrganizationsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'payroll',
    loadChildren: () => import('./+payrolls/payrolls.module').then(m => m.PayrollsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'postpayroll',
    loadChildren: () => import('./+postpayroll/postpayroll.module').then(m => m.PostPayrollModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'payrolls-validation',
    loadChildren: () => import('./+payrolls-validation/payrolls-validation.module').then(m => m.PayrollsValidationModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'dsn',
    loadChildren: () => import('./+dsn/dsn.module').then(m => m.DSNModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./+reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthenticationGuard, RouteGuard]
  },
  {
    path: 'template-management',
    loadChildren: () => import('./template-management/template-management.module').then(m => m.TemplateManagementModule),
    canActivate: [AuthenticationGuard, RouteGuard]
  },
  {
    path: 'configuration',
    loadChildren: () => import('./+configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'mass-data-update',
    loadChildren: () => import('./+mass-data-update/mass-data-update.module').then(m => m.MassDataUpdateModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'hire-profile',
    loadChildren: () => import('./hire-profile/hire-profile.module').then(m => m.HireProfileModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'inbox',
    loadChildren: () => import('./inbox/inbox.module').then(m => m.InboxModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'process-reply-email',
    loadChildren: () => import('./process-reply-email/process-reply-email.module').then(m => m.ProcessReplyEmailModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'sdconnect',
    loadChildren: () => import('./sdconnect-admin/sdconnect-admin.module').then(m => m.SdconnectAdminModule),
    canActivate: [AuthenticationGuard]
  },
  // Default redirect to dashboard
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard'
  },

  {
    path: '**',
    redirectTo: '404'
  }
    ]
  }
];
